module.exports = __webpack_public_path__ + "media/images/sp/specials/okinawa_churaumi_aquarium/plan_location_nakijin-9623d200ffb9b23b566e5237414bb93f.jpg";